<template>
  <teleport to="#app-notification">
    <tr-alert-notification
      v-if="shouldShowAlertNotification"
      :full-width="true"
      type="danger"
    >
      <tr-typography>
        Você está com faturas em atraso.
        <router-link
          class="underlined cursor-pointer"
          :to="{ name: 'BillingPage' }"
        >
          Veja suas faturas
        </router-link> e
        regularize, evitando bloqueios.
      </tr-typography>
    </tr-alert-notification>
  </teleport>
</template>

<script>
import billingResource from '@/apps/admin/billing/resources/billing';
import loggedUserResource from '@/commons/resources/loggedUser';
import appSettingsResource from '@/apps/payments/resources/settings';
import { getMessage } from '@/commons/services/error';
import { companyStatus, roles } from '@transfeeradev/api-enums';

export default {
  name: 'billing-overdue-notification',
  data: () => ({
    hasOverdue: false,
    isBlocked: false,
    isAdmin: false,
    hasShowBillingInfoConfig: true,
    shouldShowAlertNotification: false
  }),
  async created() {
    const loggedUser = loggedUserResource.get();
    this.isBlocked = loggedUser.company.status === companyStatus.BLOCKED;
    this.isAdmin = loggedUser.profile === roles.appRoles.ADMIN.value;

    if (this.isBlocked) {
      return;
    }

    appSettingsResource.get().then(response => {
      const { showFinanceInfo } = response;
      this.hasShowBillingInfoConfig = showFinanceInfo;
    });

    try {
      const result = await billingResource.hasOverdue();
      this.hasOverdue = result.data;
    } catch (error) {
      this.$toaster.error(getMessage(error));
    }

    this.setShouldShowAlertNotification();
  },
  methods: {
    setShouldShowAlertNotification() {
      this.shouldShowAlertNotification =
        this.hasOverdue && !this.isBlocked && this.isAdmin && this.hasShowBillingInfoConfig;
    }
  }
};
</script>
